import styled from 'styled-components';

import { colors, fontSizes, fontWeights } from '../../theme';

export const GroupContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 10px 0;
`;

export const GroupName = styled.span`
  font-size: ${fontSizes.xxs};
  font-weight: ${fontWeights.medium};
  color: ${colors.pigeon};
  text-transform: uppercase;
  letter-spacing: 1px;
`;

export const OptionContainer = styled.div`
  width: max-content;
  max-width: 100%;
`;
